// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles_dots__21gnI","popover":"styles_popover__3qQCJ","popoverText":"styles_popoverText__1OiaB","popContent":"styles_popContent__1J8iH"};